export const generateClientReferenceId = () => {
	if (import.meta.env.PROD) {
		return crypto.randomUUID();
	}

	return Math.random().toString(36).slice(2) + Date.now().toString(36);
};
